import { map, concat } from 'lodash';

export default class TeamService {
    /* @ngInject */
    constructor(apiService) {
        this.apiService = apiService;
    }

    create(team) {
        return this.apiService.post(`/teams`, team).then((result) => result.data);
    }

    update(team) {
        return this.apiService.put(`/teams/${team.id}`, {
            name: team.name
        }).then((result) => result.data);
    }

    remove(team) {
        return this.apiService.delete(`/teams/${team.id}`).then((result) => result.data);
    }

    leave(team) {
        return this.apiService.post(`/teams/${team.id}/leave`).then((result) => result.data);
    }

    getNoteMapping(teamId) {
        return this.apiService.get(`/teams/${teamId}/note-category-map`).then((result) => result.data);
    }

    getMembers(teamId) {
        return this.apiService.get(`/teams/${teamId}/members`).then((result) => result.data);
    }

    updateMembers(teamId, addedMembers, removedMembers) {
        let operations = map(addedMembers, (user) => {
            return {
                operation: 'create',
                email: user.email
            };
        });

        operations = concat(operations, map(removedMembers, (user) => {
            return {
                operation: 'delete',
                email: user.email
            };
        }));

        return this.apiService.patch(`/teams/${teamId}/members`, operations).then((result) => result.data);
    }

    reorder(ids) {
        return this.apiService.post(`/teams/order`, ids).then((result) => result.data);
    }
}



// WEBPACK FOOTER //
// ./src/application/service/team/team.service.js